export default __webpack_public_path__ + "static/Carissa-4d8378b1bf80a37be1018816a379f01f.png";